import { FilesSection } from '../FilesSection';

interface FilesTabProps {
  patientId: string;
}

export function FilesTab({ patientId }: FilesTabProps) {
  return <FilesSection patientId={patientId} />;
}
